<template>
  <DBox
    :id="'cmp-catalog-tracks-sidewindow-track_licensors'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      id="catalog-tracks-sidewindow-licensors-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('licensors')">
            <span
              @click.stop="e => onSelectRoyalty(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['royalty_account_name']"
            >
              {{ item["royalty_account_name"] + "," }}
              {{ item["contract_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('excl')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1 disabled">
                <input
                  type="checkbox"
                  :checked="item['exclude'] == '1'"
                  :disabled="true"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('share')">
            <span class="txtov text-right" :title="item['share']">
              {{ item["share"] }} %
            </span>
          </td>
          <td v-bind="tdcon('contract_share')">
            <span class="txtov text-right" :title="item['share_contract']">
              {{ item["share_contract"] }} %
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { royaltyAccountsListLDTRoutes } from "../../../royalty/router/routes";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedTrackDetails"],
  data() {
    return {
      selecteditems: new Set()
    };
  },
  mounted: function() {
    console.log("licensors  ", this.selectedTrackDetails.licensors);
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedTrackDetails.licensors || [];
    },
    headers: function() {
      return [
        createTableHeader("licensors", { f: 2 }),
        createTableHeader("excl", { mw: 50, ta: "center" }),
        createTableHeader("share", { text: "Share", ta: "right", mw: 80 }),
        createTableHeader("contract_share", {
          text: "C.Share",
          ta: "right",
          mw: 80
        })
      ];
    }
  },
  methods: {
    onSelectRoyalty: function(selectedItem) {
      console.log("selected Royalty Name ", selectedItem);
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: selectedItem.royalty_account_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-tracks-sidewindow-track_licensors {
  .dt-ntable tbody tr:last-child {
    border-bottom: none;
  }
}
</style>
